import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { get } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Checkbox, Typography } from '@material-ui/core';
import Section from '../Section';
import { loadTexts } from '../../../../config/texts';

import { updateReviewMandatory } from '../../actions';
import { fetchUser } from '../../../auth/actions';

const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  }
});
const TEXT_KEY = "organization";

class MandatoryReview extends React.Component {
  state = {
    checked: get(this, 'props.organization.reviewMandatory') || false,
    texts: loadTexts(TEXT_KEY, this.props.locale)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedOrganization !== this.props.selectedOrganization) {
      this.setState({
        checked: get(this, 'props.organization.reviewMandatory') || false,
      });
    }
  }

  _onCancel = () => {
    this.setState({
      checked: get(this, 'props.organization.reviewMandatory') || false,
    });
  };

  _onSave = async () => {
    await this.props.updateReviewMandatory({
      organization: this.props.selectedOrganization,
      mandatory: this.state.checked,
    })
    this.props.fetchUser();
  };

  _onChange = event => {
    this.setState({ checked: event.target.checked });
  };

  render() {
    const { checked, texts } = this.state;
    const { classes, organization } = this.props;
    return (
      <Section
        onCancel={this._onCancel}
        onSave={this._onSave}
        saveDisabled={checked === (organization.reviewMandatory || false)}
        cancelDisabled={false}
      >
        <div className={classes.container}>
          <Checkbox
            checked={checked}
            onChange={this._onChange}
            color="primary"
            value="mandatory"
          />
          <Typography>
            {texts.section.review}
          </Typography>
        </div>
      </Section>
    );
  }
}

export default compose(
  withStyles(styles, { name: 'MandatoryReview' }),
  connect(
    state => {
      const selectedOrganization = get(state, 'auth.selectedOrganization');
      const organizations = get(state, 'auth.data.user.organizations') || [];
      return {
        selectedOrganization,
        organization: organizations.find(o => o._id === selectedOrganization),
        locale: state.appState.locale
      };
    },
    dispatch => ({
      updateReviewMandatory: params => dispatch(updateReviewMandatory(params)()),
      fetchUser: params => dispatch(fetchUser(params)()),
    }))
)(MandatoryReview);



// WEBPACK FOOTER //
// ./src/modules/organization/cards/MandatoryReview/index.js